import { DASH_LABELS, OEL, OEC, OER } from './dashConstants'

export const META_BY_LOCATION_DETAIL = {
  [OEL]: {
    label: DASH_LABELS.OL_PANEL,
    partOverride: '42N_OEL_Panel',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  [OEC]: {
    label: DASH_LABELS.OC_PANEL,
    partOverride: '42N_OEC_Panel',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
  [OER]: {
    label: DASH_LABELS.OR_PANEL,
    partOverride: '42N_OER_Panel_Integrated_Storage',
    noTooltip: true,
    noFallback: true,
    openListView: true,
    noShowPartNumber: true,
  },
}

export const DASH_META = {
  name: 'OVERHEAD_4E1_018_EXTENDED',
  panels: [OEL, OEC, OER],
  width: 4000,
  height: 700,
  panelsStyle: `
  display: flex;
  align-items: baseline;
`,
}

export const FALLBACK_COMPONENTS_BY_DETAIL = {}

export default {
  ...DASH_META,
  ...META_BY_LOCATION_DETAIL,
  fallbacks: FALLBACK_COMPONENTS_BY_DETAIL,
  lists: {
    [OEL]: {
      id: OEL,
      label: DASH_LABELS.OL_PANEL,
      groups: {
        OEL91: {
          order: 0,
          id: 'OEL91',
          panel: OEL,
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'Left MSF',
          detail: ['QQ'],
        },
      },
    },
    [OEC]: {
      id: OEC,
      label: DASH_LABELS.OC_PANEL,
      groups: {
        OEC91: {
          order: 0,
          id: 'OEC91',
          panel: OEC,
          isMsfOrMst: true,
          canDragGroup: true,
          label: 'Left MSF',
          detail: ['QQ'],
        },
        OEC92: {
          order: 1,
          id: 'OEC92',
          panel: OEC,
          label: 'Center MSF',
          isMsfOrMst: true,
          canDragGroup: true,
          detail: ['QQ'],
        },
        OEC93: {
          order: 2,
          id: 'OEC93',
          panel: OEC,
          label: 'Right MSF',
          isMsfOrMst: true,
          canDragGroup: true,
          detail: ['QQ'],
        },
      },
    },
    [OER]: {
      id: OER,
      label: DASH_LABELS.OR_PANEL,
      hideAddMsf: true,
      isOverheadPocket: true,
      groups: {},
    },
  },
}
